import { render, staticRenderFns } from "./FormPage4.vue?vue&type=template&id=af5ba0b6&scoped=true&"
import script from "./FormPage4.vue?vue&type=script&lang=js&"
export * from "./FormPage4.vue?vue&type=script&lang=js&"
import style0 from "./FormPage4.vue?vue&type=style&index=0&id=af5ba0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5ba0b6",
  null
  
)

export default component.exports